import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { ACL_DEFAULT_CONFIG } from './acl.config';
import { AclService } from './acl.service';

/**
 * Routing guard prevent unauthorized users visit the page.
 *
 * ```ts
 * data: {
 *  path: 'home',
 *  canActivate: [ AclGuard ],
 *  data: { roles: ['FUNC__FUNC_APPROVAL_APPROVER__APPROVALS'] }
 * }
 * ```
 */
@Injectable({
  providedIn: 'root',
})
export class AclGuard implements CanActivate {
  constructor(
    private router: Router,
    private aclService: AclService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    const roles = route.data['roles'];
    return this.canAbility(roles, state.url);
  }

  canAbility(roles: string[], url: string): Promise<boolean> {
    return this.aclService.canAbility().then(ability => {
      if (!roles || roles.length === 0) {
        return true;
      }

      if (ability) {
        const hasAnyFunction = this.aclService.hasAnyFunction(roles);
        if (hasAnyFunction) {
          return true;
        }
        this.router.navigate([ACL_DEFAULT_CONFIG.guard_url]);
        return false;
      }

      return false;
    });
  }
}
